import { RangeValidator } from "./rangeValidator";
import { RuleValidator } from "../ruleValidator";

export class NumericValidator{

    private static readonly ruleValidators = [RangeValidator];

    static get(validationRule: string): RuleValidator | null {
        for (const ruleValidator of this.ruleValidators) {
            const validator = ruleValidator.parse(validationRule);
            if (validator) {
                return validator;
            }
        }
    
        return null;
    }
}